const awsmobile = {
  aws_appsync_graphqlEndpoint: 'https://mn4tg3grufewnkukvgpwdgnctm.appsync-api.ap-northeast-1.amazonaws.com/graphql',
  aws_appsync_region: 'ap-northeast-1',
  aws_appsync_authenticationType: 'API_KEY',
  aws_appsync_apiKey: 'da2-b25ab72h5jhpllivmapdo57oyq',
  Auth: {
    region: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_rOmBAGq23',
    userPoolWebClientId: '266hsqbn1hrjaj2eqkv1kbiuo6',
  },
};

export default awsmobile;
